import { isDefined } from '@aloft/toolkit-shared';
import { ProductColor } from '@aloft/toolkit-sui';

import { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2, isSubRows } from '../types.ts';

export function cellBackgroundColor(
  col?: BreakdownColumn,
  props?: Tkv2PairedCostSummaryInterfaceV2,
  compId?: string,
) {
  const backgroundColor: { backgroundColor?: ProductColor } = {};
  if (isDefined(col) && isDefined(props) && !isSubRows(col) && isDefined(col.cellColorFormatter)) {
    backgroundColor.backgroundColor = col.cellColorFormatter({
      ...props,
      compId,
    });
  }

  return backgroundColor;
}
